let mainSwiper; // Declare globally

(function () {
  const initSliders = () => {
    $(".tabs-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return;
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".tabs");
      const autoplay = box.data("autoplay");
      //const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const isProductPage = box.hasClass("product-tabs");
      console.log($(this));

      let swiperParms = {
        effect: box.data("effect"),
        speed: box.data("speed") * 1000,
        slidesPerView: 1,
        autoHeight: true,
        keyboard: true,
        loop: false,
        watchSlidesProgress: true,
        allowTouchMove: false,
      };

      if (autoplay) {
        swiperParms.autoplay = {
          delay: delay,
          //pauseOnMouseEnter: stopAutoplay,
          disableOnInteraction: false,
        };
      }

      mainSwiper = new Swiper(`#${id} .tabs_box`, swiperParms);
      document.dispatchEvent(new Event("mainSwiperInitialized"));
      let secondSwiperElement = $(this).find(".tabs_box-content");
      if (secondSwiperElement.length > 0) {
        const secondSwiper = new Swiper(
          `#${id} .tabs_box-content`,
          swiperParms
        );
        //console.log("secondSwiper initialized successfully:", secondSwiper);
        mainSwiper.on("slideChange", function () {
          secondSwiper.slideTo(mainSwiper.activeIndex);
        });
        secondSwiper.on("slideChange", function () {
          mainSwiper.slideTo(secondSwiper.activeIndex);
        });

        //const swiperHeight = secondSwiper.height;
        //const slides = secondSwiperElement.find(".swiper-slide");
        //slides.each(function () {
        //	$(this).css("height", swiperHeight + "px");
        //});
      }
      //else {
      //	console.log("Second swiper element not found.");
      //}

      console.log(isProductPage);
      const sliderThumbs = new Swiper(`#${id} .tabs-thumb_wrapper`, {
        spaceBetween: 16,
        slidesPerView: isProductPage ? 3.4 : 1.4,
        freeMode: false,
        allowTouchMove: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        loop: false,
        breakpoints: {
          576: {
            slidesPerView: 2.2,
          },
          990: {
            slidesPerView: box.data("per-row"),
            allowTouchMove: false,
          },
        },
      });

      function updateActiveSlide(mainSwiper, sliderThumbs) {
        let activeIndex = mainSwiper.activeIndex;
        if (mainSwiper.params.loop) {
          activeIndex = mainSwiper.realIndex;
        }
        const activeThumb = sliderThumbs.slides[activeIndex];
        sliderThumbs.slides.forEach(function (slide) {
          slide.classList.remove("active");
        });
        activeThumb.classList.add("active");
      }

      mainSwiper.on("slideChange", function () {
        updateActiveSlide(mainSwiper, sliderThumbs);
        if (
          mainSwiper.isEnd &&
          mainSwiper.realIndex !== mainSwiper.slides.length - 1
        ) {
          mainSwiper.slideTo(0);
        }
      });

      sliderThumbs.on("click", function (e) {
        const clickedIndex = sliderThumbs.clickedIndex;
        if (clickedIndex != null) {
          mainSwiper.slideTo(clickedIndex);
        }
      });

      sliderThumbs.slides[0].classList.add("active");
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initSliders();
    document.addEventListener("shopify:section:load", function () {
      initSliders();
    });
  });
})();
